import { SectionStatType } from "seneca-common/features/assignments/features/student-assignments/state/models/SectionStat";

export function getBestScore(sectionStat: SectionStatType) {
  return sectionStat.bestScore;
}

export function getTotalStudyTime(sectionStat: SectionStatType) {
  return sectionStat.totalStudyTime;
}
